import { getStylesObjFromCss } from '../../../../../utils/common/styling.js';

var styles = getStylesObjFromCss({
    styles: {
        root: {
            padding: "0px 18px 18px",
            display: "flex",
            flexDirection: "column",
        },
    },
    componentName: "MembersPanelList",
});

export { styles };
//# sourceMappingURL=MembersList.styles.js.map
